export class BannerButton {
  /**
   * General use banner button class.
   * @param { string } text - Button text.
   * @param { string } background - Determines background color of button.
   * @param { string } color - Determines color of button text.
   * @param { Object } state - Determines state passed by button.
   * @param { string} to - Determines Link to location of buutton.
   */
  constructor(text, background, color, state, to) {
    this.text = text
    this.background = background
    this.color = color
    this.state = state
    this.to = to
  }
}

export default BannerButton
